module.exports = __webpack_public_path__ + "img/manualIcon.1beee991.svg";